<template>
  <div class="px-4 py-3 p pt-0 custom-padding">
    <v-col class="pr-2 pt-0" cols="12">
      <v-card
        class="py-3 ma-0"
        outlined
        style="background: #FEFBFB"
        tile
      >
        <div class="d-flex align-center justify-space-between">
          <template v-if="$route.query.record_type && $route.query.record_type=== RECORD_TYPE.UPSALE">
              <div style="font-weight: 600; font-size: 16px;">
                TẠO ĐƠN HÀNG CHUYỂN ĐỔI
              </div>
               <v-btn min-width="70" height="32" class="mr-0" color="#AC0606" @click="cancelUpSale">
                 Hủy bỏ chuyển đổi
               </v-btn>
          </template>
          <template v-else>
            <div v-if="!$route.query.order" style="font-weight: 600; font-size: 16px;">
              TẠO ĐƠN HÀNG
            </div>
            <div v-else class="d-flex">
              <div class="d-flex chip-status">
                <v-icon color="#AC0606" class="mr-1">
                  mdi-currency-usd
                </v-icon>
                <div style="font-size: 14px;">
                  Thông tin đơn hàng
                </div>
                <div style="font-weight: 600;font-size: 14px;" class="mx-1">
                  {{detailOrder && detailOrder.code ? detailOrder.code : ''}}
                </div>
              </div>
              <div v-if="detailOrder && detailOrder.contactStatus" class="d-flex chip-status ml-3" :style="{ backgroundColor: detailOrder.contactStatus.color }">
                <div style="font-size: 14px;font-weight: 600">
                  {{`${detailOrder.contactStatus.type}-${detailOrder.contactStatus.name}`}}
                </div>
              </div>
            </div>
            <div v-if="!$route.query.record_type">
              <v-btn
                  v-if="!$route.query.order && checkAuthorization('back-order-old_read')"
                  min-width="70"
                  height="32"
                  class="mr-0"
                  color="#AC0606"
                  @click="backToOldVersion"
              >
                Chuyển về luồng cũ
              </v-btn>
              <v-btn
                  v-if="!$route.query.order"
                  min-width="70"
                  height="32"
                  class="mr-0 ml-2"
                  color="#AC0606"
                  @click="back"
              >
                Quay lại
              </v-btn>
            </div>
          </template>
          <!-- <div v-if="$route.query.record_type == 'transfer_product'">
            <v-btn
              min-width="70"
              height="32"
              class="mr-0 ml-2"
              color="#AC0606"
              @click="backTransferProduct()"
            >
                Quay lại màn quy đổi
            </v-btn>
          </div> -->
        </div>
      </v-card>
    </v-col>
    <v-form ref="form" v-model="valid" lazy-validation class="pr-0">
      <div class='d-flex justify-space-between' style="height: 85vh;">
        <div style="width:74%">
          <div style="background: #fff; border: 1px solid #cccccc80; border-radius: 4px;" class="mb-3">
            <v-row class="px-3">
              <v-col cols="5" v-if="dataForm.customers">
                <v-card
                  class="py-3 px-4 ma-0"
                  style="background: #fffafa; border: 1px solid #cccccc80;"
                  outlined
                  tile
                >
                  <div class="d-flex">
                    <div class="d-flex pr-3" style="border-right: 1px solid #CCCCCC;">
                      <div class="align-center d-flex flex-column justify-space-between">
                        <v-icon style="color: #AC0606" size="x-large">mdi-account-circle</v-icon>
                        <div style="color: #AC0606;font-size:12px">Khách hàng</div>
                      </div>
                    </div>
                    <div>
                      <div style="font-weight: bold;color:rgba(0, 0, 0, 0.75)" class="mx-3 mb-1">
                        {{ customerName }} - {{ customerPhone }}
                      </div>
                      <div>
                        <span style="color: #0075FF;font-size: 14px; cursor: pointer;" class="mx-3"  @click="clickContact(contactId)">Xem chi tiết thông tin  <v-icon style="color: #0075FF" size="small">mdi-open-in-new</v-icon></span>
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="7">
                <v-card
                  class="py-3 px-4 ma-0"
                  style="background: #fffafa; border: 1px solid #cccccc80;"
                  outlined
                  tile
                >
                  <div class="d-flex">
                    <div class="d-flex pr-3" style="border-right: 1px solid #CCCCCC;">
                      <div class="align-center d-flex flex-column justify-space-between">
                        <v-icon style="color: #AC0606" size="x-large">mdi-truck-delivery-outline</v-icon>
                        <div style="color: #AC0606;font-size:12px">Giao Hàng</div>
                      </div>
                    </div>
                    <div>
                      <div v-if="detailOrder" style="font-weight: bold;color:rgba(0, 0, 0, 0.75)" class="mx-3 mb-1">
                        {{detailOrder.receiver}} - {{detailOrder.phone}}
                      </div>
                      <div v-else style="font-weight: bold;color:rgba(0, 0, 0, 0.75)" class="mx-3 mb-1">
                        {{ receiverName }} - {{ phone }}
                      </div>
                      <div v-if="detailOrder" style="color:rgba(0, 0, 0, 0.75)" class="mx-3">
                        {{ detailOrder.detailAddress }}, {{ detailOrder.ward && detailOrder.ward.ten ? detailOrder.ward.ten : ''  }}, {{ detailOrder.district && detailOrder.district.ten ? detailOrder.district.ten : '' }}, {{ detailOrder.province && detailOrder.province.ten ? detailOrder.province.ten : '' }}
                      </div>
                      <div v-else style="color:rgba(0, 0, 0, 0.75)" class="mx-3">
                        {{ detailAddress }}, {{ listWardObj[wardId] || null }}, {{ listDistrictObj[districtId] || null }}, {{ listProvinceObj[provinceId] || null }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
          <div v-if="detailOrder && detailOrder.noteSortClass  && detailOrder.metadata
                  && detailOrder.metadata.operationType === ORDER_OPERATION_TYPE.UP_SALE_ORDER"
               style="background: rgba(0, 117, 255, 0.2); font-style: italic; column-gap: 5px; border-radius: 4px;color: rgba(85, 85, 85, 1); padding:6px 6px 6px 12px;align-items: stretch" class="d-flex mt-4 mb-4">
            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.86275 3.75242V5.05183H7.16558V3.75242H5.86275ZM7.817 10.2495V8.95005H7.16558V6.35124H5.21133V7.65065H5.86275V8.95005H5.21133V10.2495H7.817ZM13.0283 7.00094C13.0283 10.5743 10.097 13.498 6.51417 13.498C2.93138 13.498 0 10.5743 0 7.00094C0 3.42757 2.93138 0.503906 6.51417 0.503906C10.097 0.503906 13.0283 3.42757 13.0283 7.00094ZM11.7255 7.00094C11.7255 4.12925 9.39343 1.80331 6.51417 1.80331C3.6349 1.80331 1.30283 4.12925 1.30283 7.00094C1.30283 9.87263 3.6349 12.1986 6.51417 12.1986C9.39343 12.1986 11.7255 9.87263 11.7255 7.00094Z" fill="#0075FF"/>
            </svg>
           {{ detailOrder.noteSortClass }}
          </div>
          <div style="background: #fff; border: 1px solid #cccccc80; border-radius: 4px;">
            <div v-if="$route.query.record_type === RECORD_TYPE.UPSALE" class="mt-3 pb-1 px-3">
              <div class="text-left" style="font-size: 16px; font-weight: 700">
                Sản phẩm gốc
              </div>
              <div class="ma-2">
                <div
                  v-for="(prod, idx) in selectOriginalProduct"
                  :key="'modal prod' + idx"
                  class="d-flex justify-space-between my-1"
                >
                  <div>
                    <v-checkbox
                      v-model="checkOriginalProd"
                      :label="prod.productName"
                      class="custome-checkbox"
                      disabled
                    ></v-checkbox>
                  </div>
                  <div>{{ prod.customer && prod.customer.fullName ? prod.customer.fullName : '' }}</div>
                </div>
              </div>
              <div class="danger-text">
                <v-icon color="#FF0000" class="mr-2"
                  >mdi-information-slab-circle</v-icon
                >
                Lưu ý: Việc chuyển đổi sẽ tạo ra đơn hàng mới, sản phẩm gốc sẽ bị thu
                hồi toàn bộ khuyến mại, quota nghỉ phép/bảo lưu …
              </div>
            </div>
            <div class='d-flex justify-space-between mt-3 pb-1 px-3'>
              <template v-if="$route.query.record_type === RECORD_TYPE.UPSALE">
                <h3 class="my-auto">Sản phẩm đích</h3>
              </template>
              <template v-else>
                <h3 class="my-auto">Sản phẩm mua</h3>
                <div class="text-center" v-if="!isDetailOrder && !$route.query.record_type">
                  <v-menu :offset-y="true" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          v-bind="attrs"
                          v-on="on"
                          min-width="70"
                          height="32"
                          class="mr-0"
                          color="#AC0606"
                      >
                        <span style="font-size: 12px" class="mr-1">✢ </span>Thêm sản phẩm
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="addProduct('tutor')">
                        <v-list-item-title>Sản phẩm gia sư</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="addProduct('duo')">
                        <v-list-item-title>Sản phẩm khóa học</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="addProduct('combo')">
                        <v-list-item-title>Sản phẩm combo</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
                <div class="text-center"
                     v-if="(checkAuthorization('convert-basic-product_read') || checkAuthorization('advanced-product-conversion_read'))
                      && isDetailOrder && !$route.query.record_type && listProductTransference.length > 0"
                    >
                  <v-btn
                      min-width="70"
                      height="32"
                      class="mr-0"
                      color="#F56C22"
                      @click="showPopupUpSale()"
                  >
                    <span style="font-size: 12px" class="mr-1"><v-icon>mdi-swap-horizontal-bold</v-icon></span>Chuyển đổi sản phẩm
                  </v-btn>
                </div>
              </template>
            </div>
            <div id="style-2" v-if="products && products.length" style="height: 660px;overflow-y: auto;">
              <v-row v-for="(product, indexProd) in products" :key="indexProd" class="mx-0">
                <!--Sản phẩm gia sư-->
                <v-col v-if="product.type == 'tutor' || product.productType == 'sku_tutor'">
                  <TutorProduct
                    :product="product"
                    :indexProd="indexProd"
                    :isDetailOrder="isDetailOrder"
                    :curriculums="curriculums"
                    :teacherTypes="teacherTypes"
                    :curriculumObj="curriculumObj"
                    :teacherTypeObj="teacherTypeObj"
                    :classTypeObj="classTypeObj"
                    :innerWidth="innerWidth"
                    :childs="childs"
                    :sortedChilds="sortedChilds"
                    :skuTutors="skuTutors"
                    :cache-auto-fill="cacheAutoFill"
                    @showDetailKM="showDetailKM($event)"
                    @deleteProduct="deleteProduct($event)"
                    @openCouponModal="openCouponModal($event)"
                  />
                </v-col>
                <!--Sản phẩm gia sư-->

                <!--Sản phẩm khóa học-->
                <v-col v-if="product.type == 'duo'">
                  <DuoProduct
                    :product="product"
                    :indexProd="indexProd"
                    :isDetailOrder="isDetailOrder"
                    :childs="childs"
                    :subjectObj="subjectObj"
                    :levelObj="levelObj"
                    :gradeObj="gradeObj"
                    :activeTypeObj="activeTypeObj"
                    :innerWidth="innerWidth"
                    :sortedChilds="sortedChilds"
                    :skuDuos="skuDuos"
                    :cache-auto-fill="cacheAutoFill"
                    @showDetailKM="showDetailKM($event)"
                    @deleteProduct="deleteProduct($event)"
                    @openCouponModal="openCouponModal($event)"
                  />
                </v-col>
                <!--Sản phẩm khóa học-->

                <!--Sản phẩm combo-->
                <v-col v-if="product.type == 'combo'">
                  <ComboProduct
                    :product="product"
                    :indexProd="indexProd"
                    :isDetailOrder="isDetailOrder"
                    :childs="childs"
                    :cache-auto-fill="cacheAutoFill"
                    :skuCombos="skuCombos"
                    :subjectObj="subjectObj"
                    :innerWidth="innerWidth"
                    :sortedChilds="sortedChilds"
                    @deleteProduct="deleteProduct($event)"
                    @openCouponModal="openCouponModal($event)"
                    @viewDetailCombo="viewDetailCombo($event)"
                    @showDetailKM="showDetailKM($event)"
                  />
                </v-col>
                <!--Sản phẩm combo-->
              </v-row>
            </div>
            <div v-else class="d-flex w-100 justify-center align-center" style="height: 660px;">
              <div class="d-flex flex-column align-center">               
                <svg width="58" height="50" viewBox="0 0 58 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M57.125 46.875V40.625H16.5V46.875H57.125ZM57.125 28.125V21.875H16.5V28.125H57.125ZM16.5 9.375H57.125V3.125H16.5V9.375ZM4 3.125V9.375H10.25V3.125H4ZM0.875 3.125C0.875 2.2962 1.20424 1.50134 1.79029 0.915292C2.37634 0.329241 3.1712 0 4 0H10.25C11.0788 0 11.8737 0.329241 12.4597 0.915292C13.0458 1.50134 13.375 2.2962 13.375 3.125V9.375C13.375 10.2038 13.0458 10.9987 12.4597 11.5847C11.8737 12.1708 11.0788 12.5 10.25 12.5H4C3.1712 12.5 2.37634 12.1708 1.79029 11.5847C1.20424 10.9987 0.875 10.2038 0.875 9.375V3.125ZM4 21.875V28.125H10.25V21.875H4ZM0.875 21.875C0.875 21.0462 1.20424 20.2513 1.79029 19.6653C2.37634 19.0792 3.1712 18.75 4 18.75H10.25C11.0788 18.75 11.8737 19.0792 12.4597 19.6653C13.0458 20.2513 13.375 21.0462 13.375 21.875V28.125C13.375 28.9538 13.0458 29.7487 12.4597 30.3347C11.8737 30.9208 11.0788 31.25 10.25 31.25H4C3.1712 31.25 2.37634 30.9208 1.79029 30.3347C1.20424 29.7487 0.875 28.9538 0.875 28.125V21.875ZM4 40.625V46.875H10.25V40.625H4ZM0.875 40.625C0.875 39.7962 1.20424 39.0013 1.79029 38.4153C2.37634 37.8292 3.1712 37.5 4 37.5H10.25C11.0788 37.5 11.8737 37.8292 12.4597 38.4153C13.0458 39.0013 13.375 39.7962 13.375 40.625V46.875C13.375 47.7038 13.0458 48.4987 12.4597 49.0847C11.8737 49.6708 11.0788 50 10.25 50H4C3.1712 50 2.37634 49.6708 1.79029 49.0847C1.20424 48.4987 0.875 47.7038 0.875 46.875V40.625Z" fill="#CCCCCC"/>
                </svg>
                <div class="mt-2">
                  <p class="mb-1 text-center" style="font-size: 12px; color:#CCCCCC">Đơn hàng trống.</p>
                  <p style="font-size: 12px; color:#CCCCCC">Ấn nút <strong>THÊM SẢN PHẨM</strong> để thêm sản phẩm vào đơn hàng</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width:25%;background: #fff; border: 1px solid #cccccc80; border-radius: 4px;">
          <div style="display:flex;justify-content: space-between;flex-flow: column;height:100%">
          <div>
            <v-card
              class="py-3 px-4 ma-0 group-into-money"
              style="background: #fff;height:fit-content"
              outlined
              tile
            >
              <v-row>
                <v-col cols="12" style="font-size: 14px;" class="py-0">
                  <div class="d-flex px-2" style="background-color: #FFE8E8; border-radius: 20px;">
                    <v-icon color="#AC0606">
                      mdi-currency-usd
                    </v-icon>
                    <div class="py-1 pt-2 px-2">
                      Thông tin thanh toán 
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-6">
                  <ul class="total-money">
                    <li class="d-flex justify-space-between"><span style="font-weight: bold;color:rgba(0, 0, 0, 0.75)">
                      <v-icon color="#000">
                        mdi-circle-small
                      </v-icon>Tổng giá trị đơn hàng</span>
                      <span style="font-weight: bold;">{{ formatCurrency(totalMoney) }}</span>
                    </li>
                    <li class="d-flex justify-space-between pt-2"><span style="font-weight: bold; color:rgba(0, 0, 0, 0.75)">
                      <v-icon color="#000">
                        mdi-circle-small
                      </v-icon>Tổng tiền được giảm</span>
                      <span class="red--text" style="font-weight: bold;">{{ formatCurrency(totalDiscount) }}</span>
                    </li>
                  </ul>
                </v-col>
              </v-row>
              <hr>
              <v-row>
                <v-col class="py-4">
                  <ul class="total-money">
                    <li class="d-flex justify-space-between"><span style="font-weight: bold; color:rgba(0, 0, 0, 0.75)">
                      <v-icon color="#000">
                        mdi-circle-small
                      </v-icon>SỐ TIỀN CẦN THANH TOÁN</span>
                      <span v-if="detailOrder" style="color: #35B707;font-weight: bold; color:rgba(0, 0, 0, 0.75)" >{{ detailOrder && detailOrder.remainsUnpaidAmount ? formatCurrency(detailOrder.remainsUnpaidAmount) : '--' }}</span>
                      <span v-else style="color: #35B707;font-weight: bold; color:rgba(0, 0, 0, 0.75)">
                        <span v-if="$route.query.record_type == 'transfer_product' && cacheAutoFill">{{formatCurrency((totalPay - cacheAutoFill.orderReceipt.amount > 0 ? totalPay - cacheAutoFill.orderReceipt.amount : 0))}}</span>
                        <span v-else>{{ formatCurrency(totalPay) }}</span>
                      </span>
                    </li>
                    <li v-if="detailOrder" class="d-flex justify-space-between pt-3">
                      <span style="font-weight: bold; color:rgba(0, 0, 0, 0.75)"><v-icon color="#000">mdi-circle-small</v-icon>SỐ TIỀN ĐÃ THANH TOÁN</span>
                      <span style="color: #35B707;font-weight: bold; color:rgba(0, 0, 0, 0.75)">{{ formatCurrency(detailOrder.paidAmount) }}</span></li>
                    <li v-if="$route.query.record_type == 'transfer_product' && cacheAutoFill" class="d-flex justify-space-between pt-3">
                      <span style="font-weight: bold; color:rgba(0, 0, 0, 0.75)"><v-icon color="#000">mdi-circle-small</v-icon>SỐ TIỀN ĐÃ THANH TOÁN</span>
                      <span style="color: #35B707;font-weight: bold; color: #35B707">{{ formatCurrency(cacheAutoFill.orderReceipt.amount) }}</span></li>
                    <li v-if="detailOrder && detailOrder.totalTransferAmount" class="d-flex justify-space-between pt-3">
                      <span style="font-weight: bold; color:rgba(0, 0, 0, 0.75)"><v-icon color="#000">mdi-circle-small</v-icon>SỐ TIỀN ĐÃ CHUYỂN ĐỔI</span>
                      <span style="font-weight: bold; color:rgba(0, 0, 0, 0.75)">{{ formatCurrency(detailOrder.totalTransferAmount) }}</span></li>
                  </ul>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-3">
                  <span style="font-weight: bold; color:rgba(0, 0, 0, 0.75)">
                    <v-icon color="#000">
                      mdi-circle-small
                    </v-icon>Hình thức thanh toán
                  </span>
                </v-col>
                <v-col class="py-0">
                  <v-select
                    :items="paymentPeriods"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn "
                    label=""
                    attach
                    dense
                    outlined
                    height="30"
                    v-model="paymentPeriod"
                    :menu-props="{ top: true, offsetY: true, maxHeight: '150' }"                                    
                    :disabled="isDetailOrder || $route.query.record_type == 'transfer_product' || $route.query.record_type == RECORD_TYPE.UPSALE"
                    class="custome-payment-type"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row v-if="paymentPeriod === 1 && !$route.query.record_type">
                <v-col class="py-3">
                  <span style="font-weight: bold;color:rgba(0, 0, 0, 0.75)">
                    <v-icon color="#000">
                      mdi-circle-small
                    </v-icon>Phương thức thanh toán
                  </span>
                </v-col>
                <v-col class="py-0">
                  <v-select
                    :items="paymentTypes"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn "
                    label=""
                    attach
                    dense
                    outlined
                    height="30"
                    v-model="paymentType"
                    :menu-props="{ top: true, offsetY: true, maxHeight: '150' }"                                    
                    :disabled="isDetailOrder"
                    class="custome-payment-type"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row v-if="$route.query.record_type == 'transfer_product'">
                <v-col class="py-3">
                  <span style="font-weight: bold;color:rgba(0, 0, 0, 0.75)">
                    <v-icon color="#000">
                      mdi-circle-small
                    </v-icon>Phương thức thanh toán
                  </span>
                </v-col>
                <v-col class="py-0">
                  <v-select
                    :items="paymentTypes"
                    item-value="id"
                    item-text="name"
                    :aLight="'right'"
                    placeholder="Chọn "
                    label=""
                    attach
                    dense
                    outlined
                    height="30"
                    disabled
                    v-model="paymentType"
                    :menu-props="{ top: true, offsetY: true, maxHeight: '150' }"                                    
                    class="custome-payment-type"
                  ></v-select>
                </v-col>
              </v-row>
              <div v-if="paymentPeriod === 2">
                <div class="d-flex justify-center">
                  <v-checkbox
                    label="Cọc trước tiền"
                    hide-details
                    v-model="isNotTrail"
                    @change="isTrail = false"
                    class="table-layout-checkbox ma-0 pa-0"                                    
                    :disabled="(isDetailOrder || $route.query.record_type == 'transfer_product')"
                  />
                  <v-checkbox
                    label="Cọc học luôn"
                    hide-details
                    v-model="isTrail"
                    @change="handleChangeToTrial()"
                    class="table-layout-checkbox ma-0 pa-0 ml-6"
                    :disabled="(isDetailOrder || $route.query.record_type == 'transfer_product') && !isEnableTrialSelect"
                  />
                </div>
              </div>
            </v-card>
            <div v-if="$route.query.record_type == RECORD_TYPE.UPSALE">
              <div class="py-3 px-3">
                <PaymentInfoVue :payment-info="cacheAutoFill" />
              </div>
            </div>
            <div v-if="detailOrder">
              <div class="py-3 px-3">
                <div v-if="loadingHistoryOrder" class="history-order-skeleton">
                  <v-skeleton-loader
                    v-for="n in 3"
                    :key="n"
                    type="list-item-avatar-two-line"
                    class="mb-3"
                  ></v-skeleton-loader>
                </div>
                <HistoryOrder 
                  v-else
                  :skuTutors="skuTutors"
                  :skuDuos="skuDuos"
                  :skuCombos="skuCombos"
                  :detailOrder="detailOrder"
                  :childs="childs"
                  :timelineEvents="timelineEvents"
                  @cancelOrder="cancelOneOrder($event)"
                />
              </div>
            </div>
          </div>
            <div v-if="!$route.query.order" style="padding:0px 10px">
              <v-row>
                <v-col>
                  <v-btn
                      height="38"
                      class="mr-0 btn-order"
                      :color="isDisableCreate ? '#b7b7b7' : '#35b707'"
                      :disabled="isDisableCreate"
                      @click="createOrder" 
                    >
                    <span>{{ $route.query.record_type == 'transfer_product' ? 'TẠO ĐƠN THANH TOÁN THÊM' : ( $route.query.record_type == RECORD_TYPE.UPSALE ? 'TẠO ĐƠN CHUYỂN ĐỔI' :  'TẠO ĐƠN')}}</span>
                    </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="$route.query.record_type == 'transfer_product'">
                <v-col>
                  <v-btn
                      height="38"
                      class="mr-0 btn-order"
                      color="#b70727"
                      @click="cancelTransferProduct()"
                    >
                    HỦY chuyển phí
                    </v-btn>
                </v-col>
              </v-row>
            </div>
            <div v-else style="padding:0px 10px">
              <v-row v-if="detailOrder && detailOrder.contactStatus && T4C4_Done.includes(detailOrder.contactStatus.code)">
                <v-col>
                  <v-btn
                      height="38"
                      class="mr-0 btn-order"
                      color="#35b707"
                      :disabled="checkStatusOrder"
                      @click="showExtraPayment()"
                    >
                    THANH TOÁN THÊM
                    </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="detailOrder && detailOrder.contactStatus && T4C4_Done.includes(detailOrder.contactStatus.code) && paymentPeriod == 2">
                <v-col>
                  <v-btn
                      height="38"
                      class="mr-0 btn-order"
                      color="#b70727"
                      :disabled="checkStatusOrder"
                      @click="cancelPayOrder('Phần còn lại của đơn hàng sẽ được hủy và không thể tiếp tục thanh toán.')"
                    >
                    HỦY PHẦN CÒN LẠI
                    </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="detailOrder && detailOrder.contactStatus && T3C3.includes(detailOrder.contactStatus.code) && showCancelPayment">
                <v-col>
                  <v-btn
                      height="38"
                      class="mr-0 btn-order"
                      color="#b70727"
                      @click="cancelPayOrder('Đơn hàng sẽ được hủy và không thể thực hiện thanh toán / đối soát.')"
                    >
                    HỦY
                    </v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </v-form>

    <v-dialog
      v-if="isShowConfirmOrder"
      v-model="isShowConfirmOrder"
      persistent
      max-width="1200"
    >
    <ConfirmOrder
      :list-product-conversion="listProductConversion"
      :contactId="contactId"
      :products="products"
      :paymentPeriod="paymentPeriod"
      :paymentType="paymentType"
      :trial-exchange-price-type="trialExchangePriceType"
      :isNotTrail="isNotTrail"
      :isTrail="isTrail"
      :receiverName="receiverName"
      :phone="phone"
      :detailAddress="detailAddress"
      :wardId="wardId"
      :districtId="districtId"
      :provinceId="provinceId"
      :listProvince="listProvince"
      :paymentPeriods="paymentPeriods"
      :childs="childs"
      :stepMoney="stepMoney"
      :extraData="extraData"
      :timelineEvents="timelineEvents"
      :note-sort-class="noteSortClass"
      :payment-types="paymentTypes"
      @close="isShowConfirmOrder = false"
      @createSuccess="createSuccess"
      @createExtraSuccess="createExtraSuccess"
      />
    </v-dialog>

    <v-dialog
      v-if="isShowMultiStepPay1"
      v-model="isShowMultiStepPay1"
      persistent
      max-width="1200"
    >
      <MultiStepPay1
        :contactId="contactId"
        :products="products"
        :paymentPeriod="paymentPeriod"
        :paymentType="paymentType"
        :isNotTrail="isNotTrail"
        :isTrail="isTrail"
        :receiverName="receiverName"
        :phone="phone"
        :detailAddress="detailAddress"
        :wardId="wardId"
        :districtId="districtId"
        :provinceId="provinceId"
        :paymentPeriods="paymentPeriods"
        :childs="childs"
        :stepMoney="stepMoney"
        :fillMoney="fillMoney"
        :moneyPay="moneyPay"
        @close="isShowMultiStepPay1 = false"
        @createOrder="showConfirm1"
        />
    </v-dialog>

    <v-dialog
      v-if="isShowMultiStepPay2"
      v-model="isShowMultiStepPay2"
      persistent
      max-width="1200"
    >
    <MultiStepPay2
      :contactId="contactId"
      :products="products"
      :paymentPeriod="paymentPeriod"
      :paymentType="paymentType"
      :isNotTrail="isNotTrail"
      :isTrail="isTrail"
      :receiverName="receiverName"
      :phone="phone"
      :detailAddress="detailAddress"
      :wardId="wardId"
      :districtId="districtId"
      :provinceId="provinceId"
      :paymentPeriods="paymentPeriods"
      :childs="childs"
      :stepMoney="stepMoney"
      :payment-types="paymentTypes"
      @close="isShowMultiStepPay2 = false"
      @createOrder="showConfirm2"
      />
    </v-dialog>
    <v-dialog
      v-if="isShowDonePay"
      v-model="isShowDonePay"
      persistent
      max-width="1200"
    >
      <ExtraPayment 
        :detailOrder="detailOrder" 
        :timelineEvents="timelineEvents" 
        :skuTutors="skuTutors" 
        :skuDuos="skuDuos"
        :skuCombos="skuCombos"
        :childs="childs" 
        @closeDialog="reloadOrder"
        @close="isShowDonePay = false" 
      />
    </v-dialog>

    <v-dialog v-if="modal" v-model="modal" persistent max-width="900">
      <coupon-modal @save="applyCoupon" :tutor-skus="skuTutors" :productSelected="productSelected" @close="closeKM()" />
    </v-dialog>
    <v-dialog
      v-if="isShowDetailCb"
      v-model="isShowDetailCb"
      persistent
      max-width="750"
    >
      <DetailCombo
        :comboIDSelect="comboIDSelect"
        :skuCombos="skuCombos"
        @close="closeDetailCb"
      />
    </v-dialog>
    <v-dialog
      v-if="isShowDetailKM"
      v-model="isShowDetailKM"
      max-width="750"
    >
      <ModalDetailBonus
        :campaign="detailBonus"
        :tutor-skus="skuTutors"
        :productSelected="productSelected"
      />
    </v-dialog>
    <v-dialog
      v-if="isShowPopupUpSale"
      v-model="isShowPopupUpSale"
      max-width="70%"
      persistent
    >
      <UpSaleModel
        :products="listProductTransference"
        :childs="childs"
        :skuTutors="skuTutors"
        :skuDuos="skuDuos"
        :skuCombos="skuCombos"
        :detailOrder="detailOrder"
        :sortedChilds="sortedChilds"
        :innerWidth="innerWidth"
        :subjectObj="subjectObj"
        :activeTypeObj="activeTypeObj"
        :gradeObj="gradeObj"
        :levelObj="levelObj"
        :curriculums="curriculums"
        :teacherTypes="teacherTypes"
        :curriculumObj="curriculumObj"
        :teacherTypeObj="teacherTypeObj"
        :classTypeObj="classTypeObj"
        @close="isShowPopupUpSale = false"
        @openCouponModal="openCouponModal($event)"
        @viewDetailCombo="viewDetailCombo($event)"
        @createReceipt="handleCreateReceipt"
      />
    </v-dialog>

  </div>
</template>

<script>
import {v1 as uuidv1} from 'uuid'
import { getDiscount } from '@/helpers/campaign';
import {addProduct_C, formatCurrencyNoD_C, verifyDataProduct} from "../create-order-new/HelperFunc";
import moment from 'moment';
import RepositoryFactory from '@/repositories/RepositoryFactory';
import PaymentQRCodeRepository from '@/repositories/PaymentQRCodeRepository';
const AddressRepository = RepositoryFactory.get('address');
const ContactRepository = RepositoryFactory.get('contact');
const ProductRepository = RepositoryFactory.get('product');
const OrderRepository = RepositoryFactory.get('order');

import ConfirmOrder from './ModalOrder/ConfirmOrder.vue';
import MultiStepPay1 from './ModalOrder/MultiStepPay1.vue';
import MultiStepPay2 from './ModalOrder/MultiStepPay2.vue';
import HistoryOrder from './HistoryOrder.vue';
import ExtraPayment from './ModalOrder/ExtraPayment.vue';
import CouponModal from './ModalOrder/CouponModal.vue';
import DetailCombo from './ModalOrder/DetailCombo';
import ModalDetailBonus from './ModalOrder/ModalDetailBonus';
import UpSaleModel from './ModalOrder/UpSaleModal';
import TutorProduct from './BlockProduct/TutorProduct';
import DuoProduct from './BlockProduct/DuoProduct';
import ComboProduct from './BlockProduct/ComboProduct';
import PaymentInfoVue from './PaymentInfo.vue';
import {ORDER_OPERATION_TYPE, RECORD_TYPE} from "../../../helpers/constants";

export default {
  name: "create-order-new",

  data() {
    return {
      listProductConversion: [],
      selectOriginalProduct: [],
      noteSortClass: '',
      valid: false,
      contactId: null,
      receiverId: null,
      provinceId: null,
      districtId: null,
      wardId: null,
      detailAddress: null,
      receiverName: null,
      phone: null,
      dataForm: {
        customers: [{}]
      },
      listProvince: [],
      listProvinceObj: {},
      listWard: [],
      listWardObj: {},
      listDistrict: [],
      listDistrictObj: {},
      products: [],
      curriculums: [],
      childs: [],
      childOrders: [],
      teacherTypes: [],
      skuTutors: [],
      skuDuos: [],
      skuCombos: [],
      subjects: [],
      subjectObj: {},
      classTypeObj: {},
      curriculumObj: {},
      teacherTypeObj: {},
      paymentPeriod: 1,
      paymentPeriods: [
        {
          id: 1,
          name: 'Một lần',
        },
        {
          id: 2,
          name: 'Nhiều lần',
        },
      ],
      paymentType: 'COD',
      paymentTypes: [
        {
          id: 'COD',
          name: 'COD',
        },
        {
          id: 'BANK',
          name: 'BANK',
        },
      ],
      isShowConfirmOrder: false,
      isShowMultiStepPay1: false,
      isNotTrail: false,
      isTrail: false,
      isShowMultiStepPay2: false,
      customerName: null,
      customerPhone: null,
      stepMoney: 0,
      detailOrder: null,
      timelineEvents: [],
      loadingHistoryOrder: false,
      isShowDonePay: false,
      T4C4_Done: ['T_DATT1P','C_DATT1P'],
      T3C3: ['COD','BANK','C_COD','C_BANK'],
      productSelected: null,
      extraData: null,
      grades: [],
      gradeObj: {},
      levelObj: {
        CO_BAN: 'Cơ bản',
        NANG_CAO: 'Nâng cao',
      },
      isShowDetailCb: false,
      comboIDSelect: null,
      activeTypeObj: {
        student_self_activation: 'Học sinh tự kích hoạt',
        on_order_activation: 'Kích hoạt khi lên đơn',
        scheduled_activation: 'Hẹn ngày kích hoạt',
      },
      modal: false,
      isShowDetailKM: false,
      detailBonus: null,
      cacheAutoFill: null,
      trialExchangePriceType: 1,
      isShowPopupUpSale: false,
      checkOriginalProd: true,
      listProductTransference: [],
    };
  },
  watch: {
    paymentPeriod(val) {
      if (val) {
        this.isNotTrail = false;
        this.isTrail =
            (this.$route.query.record_type && this.totalPay &&
            (this.totalPay - this.cacheAutoFill.orderReceipt.amount > 0))
            || this.$route.query.record_type === RECORD_TYPE.UPSALE
                ? true : false;

      }
      if(val == 2) {
        this.paymentType = 'COD';
      }
    },
    totalPay(val) {
      if ((val === 0  && this.$route.query.record_type == 'transfer_product' || (val - this.cacheAutoFill.orderReceipt.amount <= 0)) && this.$route.query.record_type) {
        console.log(111)
        this.paymentPeriod = 1;
        this.isTrail = false;
      } else {
        if (this.$route.query.record_type){
          this.paymentPeriod = 2;
          this.isTrail = true;
        }
      }
    },
  },
  computed: {
    isEnableTrialSelect() {
      return this.T4C4_Done.includes(_.get(this.detailOrder, 'contactStatus.code', '')) && this.isNotTrail;
    },
    ORDER_OPERATION_TYPE() {
      return ORDER_OPERATION_TYPE
    },
    RECORD_TYPE() {
      return RECORD_TYPE
    },
    sortedChilds() {
      return this.childs.map(it => {
        let user = it.coreUser?.userName;
        let order = this.childOrders.find(o => o.customerId == it.id);
        let main = it.coreUser?.isMainAcount || false;
        let weight = (user ? 100 : 0) +
          (main ? 10 : 0) +
          (order ? 1 : 0);
        return {
          id: it.id,
          name: it.fullName,
          user: user || 'Chưa có',
          order: order ? moment(order.createdAt).format('DD/MM/YYYY') : 'Chưa có',
          weight
        };
      }).sort((l, r) => r.weight - l.weight);
    },
    totalDiscount() {
      let val = 0;
      for (let prod of this.products) {
        val += prod.discount || 0;
      }
      return val;
    },
    totalMoney() {
      let val = 0;
      for (let prod of this.products) {
        val += (prod.count || 0) * (prod.price || 0);
      }
      return val;
    },
    totalPay() {
      return Math.max(0, this.totalMoney - this.totalDiscount);
    },
    isDisableCreate() {
      const paymentMethod = this.paymentTypes.find(item => item.id === this.paymentType);
      if(paymentMethod &&  paymentMethod.amountRemaining && this.totalPay > 0) {
        const totalReceipt = paymentMethod && paymentMethod.amountRemaining ? paymentMethod.amountRemaining : 0;
        return this.totalPay > totalReceipt;
      }
      return this.products.find(item => item.productId) ? false : true;
    },
    checkStatusOrder() {
      const status = this.timelineEvents.find(item => ['init','in_progress'].includes(item.status));
      if (status) {
        return true;
      }
      return false;
    },
    isDetailOrder() {
      if(this.$route.query.record_type === RECORD_TYPE.UPSALE) {
        return true;
      }
      return this.$route.query.order ? true : false;
    },
    showCancelPayment() {
      if (this.paymentPeriod == 1) {
        return true;
      }
      const status = this.timelineEvents.find(item => item.status == 'final_success');
      if (!status && this.paymentPeriod == 2) {
        return true;
      }
      return false;
    },
    innerWidth() {
      return window.innerWidth;
    },
    fillMoney() {
      return this.cacheAutoFill ? this.totalPay - this.cacheAutoFill.orderReceipt.amount : 0
    },
    moneyPay() {
      return this.cacheAutoFill ? this.cacheAutoFill.orderReceipt.amount : 0
    },
  },
  components: {
   ConfirmOrder,
   MultiStepPay1,
   MultiStepPay2,
   HistoryOrder,
   ExtraPayment,
   CouponModal,
   DetailCombo,
   ModalDetailBonus,
   TutorProduct,
   DuoProduct,
   ComboProduct,
   UpSaleModel,
   PaymentInfoVue,
  },

  async created() {
    const loading = this.$loading.show();
    this.contactId = parseInt(this.$route.params.id);
    this.getProvinces();
    await this.getContactAddress();
    this.getContactInfo();
    this.getCurriculumAttributes();
    this.getListAttributes();
    this.callApiPaymentMethod()
    if (this.$route.query.order) {
      await this.getOrderDetail(this.$route.query.order);
      this.products = await this.formatProducts(this.products);
      loading.hide();
      await this.getListProductTransference()
    } else {
      await this.getTutorSku();
      await this.getDuoSku();
      await this.getComboSku();
      if (this.$route.query.record_id) {
        await this.getAutoFillOrderDetail();
      } else {
        if (this.$store.state.module.schoolLevelId === 1 && (this.$store.state.module.typeId == 1 || this.$store.state.module.typeId == 3 )) {
          addProduct_C(this.products, 'duo', this.skuDuos);
        } else {
          addProduct_C(this.products, 'tutor', this.skuTutors);
        }
        
      }
      loading.hide();
    }
    console.log(this.paymentPeriod, 'this.paymentPeriod')
  },
  mounted() {
    if (typeof Bus !== 'undefined' && Bus) {
      Bus.$on('transfer-qr-code-success', this.handleTransferQrCodeSuccess);
    }
  },
  beforeDestroy() {
    if (typeof Bus !== 'undefined' && Bus) {
      Bus.$off('transfer-qr-code-success', this.handleTransferQrCodeSuccess);
    }
  },
  methods: {
    async callApiPaymentMethod() {
      try{
        const response = await OrderRepository.getPaymentMethodApi(this.contactId);
        if(response.success) {
          const optionReceipt = this.paymentTypes.find(item => item.id == 'MONEY_RECEIPT');
          if(!optionReceipt && response.data.length > 0) {
              const newPaymentTypes = response.data.map(item => ({
                id: `MONEY_RECEIPT-${item.id}`,
                name: `Biên nhận${item.amountRemaining ? ' - ' + formatCurrencyNoD_C(item.amountRemaining) : ''}`,
                value: item.id,
                amountRemaining: item.amountRemaining ? item.amountRemaining : 0
              }));
              this.paymentTypes.push(...newPaymentTypes);
            }
          }
      }catch (e) {
        console.log(e)
      }
    },
    handleTransferQrCodeSuccess(data = {}) {
      const receiptId = data && data.receiptId ? String(data.receiptId) : null;
      const status = data && data.status !== undefined ? data.status : null;
      
      if (!receiptId || status === null) {
        return;
      }
      
      // Cập nhật timelineEvents: nếu receiptId khớp và status = 1 thì đổi status sang final_success
      this.timelineEvents = this.timelineEvents.map(event => {
        const eventReceiptId = event.id ? String(event.id) : null;
        if (event.objectType === 'order_receipt' && eventReceiptId === receiptId && status === 1) {
          if (this.detailOrder?.contactStatus) {
            this.detailOrder.contactStatus.code = '';
          }

          return {
            ...event,
            status: 'final_success'
          };
        }
        return event;
      });
    },
    async syncPaymentQRCodeSuccess() {
      const orderId = this.$route.query.order;
      if (!orderId || !this.detailOrder) {
        return;
      }
      this.loadingHistoryOrder = true;
      try {
        const response = await PaymentQRCodeRepository.getPaymentQRCodeSuccess({ order_id: orderId });
        if (response && response.data && response.data.isSuccess && Array.isArray(response.data.data)) {
          const receiptCodes = response.data.data;
          // Cập nhật timelineEvents: nếu code hoặc id của phiếu thu có trong mảng receiptCodes, chuyển status sang final_success
          this.timelineEvents = this.timelineEvents.map(event => {
            if (event.objectType === 'order_receipt' && 
                (receiptCodes.includes(event.code) || receiptCodes.includes(String(event.id)))) {
              return {
                ...event,
                status: 'final_success'
              };
            }
            return event;
          });
        }
      } catch (error) {
        console.error('Error fetching payment QR code success:', error);
      } finally {
        this.loadingHistoryOrder = false;
      }
    },
    async handleCreateReceipt(response) {
      if (response && response.success) {
        this.isShowPopupUpSale = false;
        await this.getOrderDetail(this.$route.query.order);
        this.products = await this.formatProducts(this.products);
        await this.getListProductTransference()
        await this.callApiPaymentMethod()
      }
    },
    handleChangeToTrial(e) {
      if (this.isDetailOrder && this.isEnableTrialSelect) {
        this.$swal({
          title: 'Chuyển từ Cọc trước tiền sang Cọc học luôn !',
          confirmButtonText: 'Xác nhận',
          cancelButtonText: 'Hủy',
          showCancelButton: true,
        }).then(async (res) => {
          if (res.value) {
            const result = await OrderRepository.updateDepositLean(this.detailOrder.orderId);
            if (result.success) {
              this.$swal({
                icon: 'success',
                title: 'Cập nhật đơn hàng thành công.',
                timer: 3000,
              })
              this.isNotTrail = false;
              await this.getOrderDetail(this.$route.query.order);
              this.products = await this.formatProducts(this.products);
              await this.getListProductTransference()
            } else {
              this.$swal({
                icon: 'error',
                title: 'Có lỗi xảy ra!',
                timer: 3000,
              })
              this.isTrail = false;
            }
          }
          else {
            this.isTrail = false;
          }
        })
      }
      else {
        this.isNotTrail = false;
      }
    },
    // isEnableTrialSelect() {
    //   return this.T4C4_Done.includes(this.detailOrder.contactStatus.code) && this.isNotTrail;
    // },
    async getOrderReceipt() {
      const params = {
        order_code: this.detailOrder.code,
      };
      const response = await OrderRepository.getOrderReceiptApi(params);
      if (response && response.status !== 200) {
        this.timelineEvents = response.data;
      }
    },
    async formatProductUpSale(response) {
      this.cacheAutoFill = _.cloneDeep(response);
      this.products = await this.formatProducts(response.products);
      this.selectOriginalProduct =  _.cloneDeep(response.oldProducts);
      this.paymentPeriod = response.paymentPeriod;
      console.log(response.paymentPeriod, 'response.paymentPeriod;')
      this.paymentType = response.paymentType;
      this.noteSortClass =  _.cloneDeep(response.noteSortClass);
    },
    async getAutoFillOrderDetail() {
      this.paymentTypes.push({
        id: 'MONEY_RECEIPT',
        name: 'Biên nhận',
      });
      const params = {
        record_id: this.$route.query.record_id,
        record_type: this.$route.query && this.$route.query.isDuo ? 'cross_transfer_product' : this.$route.query.record_type,
      }
      const res = await OrderRepository.getAutoFillOrderDetail(params);
      if(this.$route.query.record_type === RECORD_TYPE.UPSALE) {
        // await this.formatProductUpSale(response.data)
        // if (res && res.data) {
          await this.formatProductUpSale(res.data)
        // }
      } else {
        if (res && res.data) {
          this.cacheAutoFill = res.data;
          if(this.$route.query && this.$route.query.isDuo) {
            console.log(res.data.products, 'res.data.products')
            this.products = await this.formatProducts(res.data.products);
          }else {
            res.data.products.forEach(item => {
              const prod = {
                type: item.productType.split('_')[1],
                curriculumId: item.sku.curriculumId,
                classTypeId: item.sku.classTypeId,
                productID: item.sku.productId,
                teacherType: item.sku.teacherTypeId,
                package: `${item.sku.classTypeId}-${item.sku.numOfLesson}`,
                productId: item.productId,
                productName: item.sku.name,
                count: item.quantity,
                price: item.price,
                discount: 0,
                intoMoney: item.intoMoney !== null ? item.intoMoney : null,
                customerId: item.customerId,
                isNew: false,
                isExtend: false,
                packageOptions: [],
                products: this.skuTutors,
                maxPrice: null,
                minPrice: null,
                priceType: item.sku.pricePolicies[0].price_type,
                campaigns: [],
                idBlock: uuidv1(),
              }
              this.getClassType(prod);
              this.products.push(prod);
            });
          }
          this.paymentPeriod = res.data.paymentPeriod;
          this.paymentType = res.data.paymentType;
          this.isTrail = true;
        }
      }
    },
    applyCoupon(product) {
      this.productSelected = null;
      product.discount = getDiscount(product);
    },
    async cancelUpSale() {
      if (!this.$route.query.record_id) {
        return
      }
      try {
        const res = await OrderRepository.cancelUpSaleOrderApi(this.$route.query.record_id,
            {draftStatus: 4}
        );
        if(res.success) {
          let routeData = this.$router.resolve({name: 'OrderDetailNew', params: { id:  res.data.contactId}, query: {order: res.data.oldOrderId},})
          window.open(routeData.href, '_self')
        }
      }catch (e) {
        console.log(e)
      }
    },
    backToOldVersion() {
      // Todo
      let routeData = this.$router.push({
        name: "OrderCreate",
        params: {
          id: this.contactId,
        },
        query: {
          oldVersion: 'true',
        },
      });
    },
    showDetailKM(item) {
      this.isShowDetailKM = true;
      this.productSelected = item.product;
      this.getDetailBonus(item.campaign);
    },
    async getDetailBonus(item) {
      const params = {
        promotion_code: item.promotionCode,
        is_from_crm: 1,
      };
      const res = await ContactRepository.getDetailBonus(params);
      if (res && res.data) {
        this.detailBonus = res.data;
      } else {
        this.$swal({
          type: 'error',
          title: 'Thông báo',
          text: 'Không tìm thấy thông tin khuyến mại',
        });
      }
    },
    openCouponModal(item) {
      // if (this.isDetailOrder) return;
      // if (this.isDetailOrder) return;
      if (!item.isNew && !item.isExtend) {
        return this.$swal({
          type: 'error',
          title: 'Thông báo',
          text: 'Chưa chọn Mua mới | Gia hạn',
        });
      }
      if (!item.productId) {
        return this.$swal({
          type: 'error',
          title: 'Thông báo',
          text: 'Chưa chọn sản phẩm',
        });
      }
      this.productSelected = item;
      this.modal = true
      // this.$refs.dlgCoupon.open(this.productSelected);
    },
    closeKM() {
      this.modal = false;
      this.productSelected = null;
    },
    async createOrder() {
      const verify = verifyDataProduct(this, this.products);
      if (verify) return;
      if (this.paymentPeriod === 1) {
        this.isShowConfirmOrder = true;
        this.stepMoney = (this.cacheAutoFill && this.cacheAutoFill.orderReceipt) ? this.cacheAutoFill.orderReceipt.amount : this.totalPay;
      }
      if (this.paymentPeriod === 2) {
        // Đặt cọc học luôn | Học thử
        if (!this.isTrail && !this.isNotTrail) {
          return this.$swal({
            type: 'error',
            title: 'Thông báo',
            text: 'Chưa chọn Cọc trước tiền | Cọc học luôn',
          });
        }

        if (this.isTrail) {
          this.isShowMultiStepPay1 = true;
        }
        if (this.isNotTrail) {
          this.isShowMultiStepPay2 = true;
        }
      }
    },
    showConfirm1(data) {
      this.isShowMultiStepPay1 = false;
      this.isShowConfirmOrder = true;
      this.stepMoney = parseInt(data.payPrice);
      this.paymentType = data.paymentType;
      this.trialExchangePriceType = data.trialExchangePriceType;
      this.listProductConversion = data.listProductConversion;
    },
    showConfirm2(data) {
      this.isShowMultiStepPay2 = false;
      this.isShowConfirmOrder = true;
      this.stepMoney = parseInt(data.payPrice);
      this.paymentType = data.paymentType;
    },
    async getTutorSku() {
      const params = {
        product_type: 'tutor',
        include_price_policy: 1,
        transaction_status: 'selling',
        status: 'active',
      };
      const res = await OrderRepository.advanceSearchForComboV2(params);
			this.skuTutors = res.data || [];
    },
    async getDuoSku() {
      const params = {
        product_type: 'duo',
        include_price_policy: 1,
        transaction_status: 'selling',
        status: 'active',
        is_from_crm: 1,
      };
      const res = await OrderRepository.advanceSearchForComboV2(params);
			this.skuDuos = res.data;
    },
    async getComboSku() {
      const params = {
        product_type: 'combo',
        include_price_policy: 1,
        transaction_status: 'selling',
        status: 'active',
        is_from_crm: 1,
      };
      const res = await OrderRepository.advanceSearchForComboV2(params);
			this.skuCombos = res.data;
    },
    async getClassType(prod) {
      if (prod.curriculumId && prod.teacherType) {
        const params = {
          curriculum_id: prod.curriculumId,
          teacher_type_id: prod.teacherType,
        }
        const res = await OrderRepository.getClassType(params);
        prod.packageOptions = res.data.map((item) => {
          return {
            uniqueId: `${item.classTypeId}-${item.numOfLesson}`,
            id: item.numOfLesson,
            idReal: item.classTypeId,
            name: `${this.classTypeObj[item.classTypeId]} - ${item.numOfLesson} buổi`,
          };
        });
      }
    },
    async getListAttributes() {
      const res = await OrderRepository.getProductAttributes();
      this.teacherTypes = res.data.teacherTypes;
      res.data.classTypes.forEach((item) => {
        this.classTypeObj[item.id] = item.name;
      });
      res.data.teacherTypes.forEach((item) => {
        this.teacherTypeObj[item.id] = item.name;
      })
      this.subjects = res.data.subjects;
      res.data.subjects.forEach((item) => {
        this.subjectObj[item.id] = item.name;
      });
      this.grades = res.data.grades;
      res.data.grades.forEach((item) => {
        this.gradeObj[item.id] = item.name;
      });
    },
    async getCurriculumAttributes() {
      const res = await ProductRepository.getCurriculumAttributes();
      this.curriculums = res.data;
      res.data.forEach((item) => {
        this.curriculumObj[item.id] = item.title;
      })
    },
    deleteProduct(data) {
      this.$store.dispatch('SET_LIST_BONUS_BY_BLOCK', {type: 'delete', object: {idBlock: data.product.idBlock}})
      this.products.splice(data.index, 1);
    },
    addProduct(type = 'tutor') {
      let listSKU = [];
      if (type === "tutor") listSKU = this.skuTutors;
      if (type === "duo") listSKU = this.skuDuos;
      if (type === "combo") listSKU = this.skuCombos;
      addProduct_C(this.products, type, listSKU)
    },
    async getContactAddress() {
      const params = {
        contactId: this.contactId,
        page: 0,
        limit: 1,
      };
      const res = await ContactRepository.getContactAddress(params);
      if (res.data && res.data.length) {
        this.receiverId = res.data[0].id;
        this.provinceId = res.data[0].provinceId;
        if (res.data[0].provinceId) {
          this.getDistricts();
        }
        this.districtId = res.data[0].districtId;
        if (res.data[0].provinceId && res.data[0].districtId) {
          this.getWards();
        }
        this.wardId = res.data[0].wardId;
        this.detailAddress = res.data[0].detailAddress;
        this.receiverName = res.data[0].receiverName;
        this.phone = res.data[0].phone;
      }
    },
    async loadChildOrders() {
      if (this.childs.length == 0) return;
      let ids = this.childs.map(it => it.id);
      let resp = await ContactRepository.getChildOrders(ids);
      let tmp = [];
      let arr = resp.data || [];
      for (let it of arr) {
        if (!it.orders || it.orders.length == 0) continue;
        tmp.push({
          id: it.orders[0].orderId,
          customerId: it.customerId,
          createdAt: it.orders[0].createdAt
        });
      }
      this.childOrders = tmp;
    },
    async getContactInfo() {
      const respond = await ContactRepository.detail(this.$route.params.id);
      if (_.get(respond, 'success', false) && _.get(respond, 'data', null)) {
        const res = await ContactRepository.getContactInfo(this.contactId);

        const dataContact = _.get(respond, 'data', {});
        const contactSourceIds = _.get(dataContact, 'contactSources', []).map(
          contactSource => contactSource.id
        );
        res.data.customers.forEach((itemX) => {
          if (itemX.position === 'child') {
            this.childs.push(itemX);
          }
        })
        // this.childs = res.data.customers || [];
        this.loadChildOrders();
        const customers = res.data.customers.map(customer => {
          const customerTemp = customer;
          customerTemp.customerId = customerTemp.id;
          customerTemp.phones = _.get(customer, 'phones', []).map(
            data => data.phoneNumber
          );
          customerTemp.isNew = false;

          if (!_.get(customer, 'isMainCustomer', false)) {
            if (!Array.isArray(customerTemp.phones)) {
              customerTemp.phones = [];
            }
            customerTemp.mobile = _.get(customerTemp, 'phones[0]', '');
            customerTemp.phones.shift();
          }

          if (customer.isMainCustomer && customer.fullName === '') {
            customerTemp.fullName = customerTemp.mobile;
          }
          if (customer.isMainCustomer) {
            if (!this.receiverName) {
              this.receiverName = customerTemp.fullName
            }
            if (!this.phone) {
              this.phone = customerTemp.mobile
            }
            if (!this.receiverId) {
              if (customer.province && customer.province.id) {
                this.provinceId = customer.province.id;
                this.getDistricts();
              }
              if (customer.district && customer.district.id) {
                this.districtId = customer.district.id; 
                this.getWards();
              }
              if (customer.ward && customer.ward.id) {
                this.wardId = customer.ward.id;
              }
              if (customer.detailAddress) {
                this.detailAddress = customer.detailAddress;
              }
            }
          }

          return customerTemp;
        });

        const mainCustomer = customers.find(
          customer => customer.isMainCustomer
        ) || {
          mobile: '',
          isMainCustomer: true,
          position: 'other',
          phones: [],
          courseRegister: []
        };

        const customersTemp = [
          mainCustomer,
          ...customers.filter(customer => !customer.isMainCustomer)
        ];

        let customerChildFirst = customersTemp.find(c => c.position === 'child');
        if (!customerChildFirst) {
          customersTemp.push( {
            customerId: new Date().getTime(),
            isMainCustomer: false,
            position: 'child',
            fullName: '',
            birthday: 0,
            courseRegister: [],
            isDataTemp: true,
          });
        }
        this.dataForm = {
          ...dataContact,
          contactSourceIds,
          customers: customersTemp,
          productGroups: dataContact.groups.map(dataGroup => dataGroup.id),
        };

        this.customerName = customersTemp[0].fullName;
        this.customerPhone = customersTemp[0].mobile;
      }
    },
    // Lấy danh sách Tỉnh/Thành Phố
    async getProvinces() {
      const respond = await AddressRepository.provinces({ limit: 100 });
      if (_.get(respond, 'success', false)) {
        this.listProvince = _.get(respond, 'data', []).filter(
          data => data.id != 0
        );
        respond.data.forEach((item) => {
          this.listProvinceObj[item.id] = item.ten;
        });
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    // Lấy danh sách Quận/Huyện
    async getDistricts() {
      const loader = this.$loading.show();
      this.districtId = null;
      this.wardId = null;
      this.listWard = [];
      const respond = await AddressRepository.districts(
        { limit: 100 },
        this.provinceId,
      );
      loader.hide();
      if (_.get(respond, 'success', false)) {
        respond.data.forEach((item) => {
          this.listDistrictObj[item.id] = item.ten;
        })
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },

    async getWards() {
      const loader = this.$loading.show();
      this.wardId = null;
      const respond = await AddressRepository.wards(
        { limit: 100 },
        this.provinceId,
        this.districtId
      );
      loader.hide();

      if (_.get(respond, 'success', false)) {
        respond.data.forEach((item) => {
          this.listWardObj[item.id] = item.ten;
        });
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    createExtraSuccess() {
      this.isShowConfirmOrder = false;
      this.getOrderReceipt();
      // this.fetchOrderHistory();
      this.extraData = null;
    },
    createSuccess() {
      this.isShowConfirmOrder = false;
      return this.$router.push({
        name: 'ContactOrderList',
        params: {
          id: this.contactId,
        }
      });
    },
    back() {
      this.isShowConfirmOrder = false;
      return this.$router.push({
        name: 'UpdateContactInfo',
        params: {
          id: this.contactId,
        }
      });
    },
    // backTransferProduct() {
    //   //TODO: back to transfer product erp && care
    // },
    cancelTransferProduct() {
      //TODO: cancel transfer product erp && care
      if (!this.$route.query.url_back) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Không thể huỷ chuyển phí lúc này! Vui lòng kiểm tra lại đường dẫn.'
        });
      }
      this.$swal({
        showCancelButton: true,
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Huỷ',
        html: 'Vui lòng xác nhận việc Hủy chuyển phí này </br> Các quy đổi đã thực hiện ở Care trước đó sẽ bị hủy'
      }).then((result) => {
        if (result.value) {
          const link = `${process.env.VUE_APP_CUSTOMER_CARE}${this.$route.query.url_back}`;
          window.location.href = link;
        }
      });
    },
    async getOrderDetail(orderId) {
      this.paymentTypes.push({
        id: 'MONEY_RECEIPT',
        name: 'Biên nhận',
      });
      const res = await OrderRepository.getOrderDetailV2(orderId);
      if(res && res.data) {
        this.detailOrder = res.data;
        this.products = this.detailOrder.orderProducts;
        this.skuTutors = this.detailOrder.orderSnapShot.skuTutors;
        this.skuDuos = this.detailOrder.orderSnapShot.skuDuos;
        this.skuCombos = this.detailOrder.orderSnapShot.skuCombos;
        if (this.detailOrder.combos && this.detailOrder.combos.length) {
          this.products = this.products.concat(this.detailOrder.combos);
        }
        this.paymentPeriod = this.detailOrder.paymentPeriod;
        this.paymentType = this.detailOrder.paymentType;
        console.log( this.detailOrder.paymentType, ' this.detailOrder.paymentType')
        // await this.fetchOrderHistory();
        await this.getOrderReceipt()
        await this.syncPaymentQRCodeSuccess()
        this.isTrail = this.detailOrder.depositType === 2 ? true : false;
        this.isNotTrail = this.detailOrder.depositType === 1 ? true : false;
      }
    },
    async formatProducts(products) {
      let results = await Promise.all(products.map(async (item) => {
        const type = item.productType.split('_')[1];
        let skus = type == 'tutor' ? this.skuTutors : this.skuDuos;
        if (type == 'combo') skus = this.skuCombos;
        const productSKU = skus.find(sku => sku.id === item.productId);
        console.log(item.campaigns, 'item.campaigns')
        const campaigns = item.campaigns.map((item) => {
          const giftSelected = (item.orderProductPromotions || []).map((itemGift) => {
            return {
              quantity: itemGift.quantity,
              skuName: itemGift.name
            };
          });
          const promo = item.orderProductPromotionDiscounts?.length
            ? item.orderProductPromotionDiscounts[0]
            : {};
          const raw = {
            type: promo.campaignType || 3,
            code: item.campaignCode,
            promotionCode: item.promotionCode,
            promotionDiscount: promo.campaignPromotionDiscount || 0,
            numberOfAvailableOrder: promo.campaignNumberOfAvailableOrder || 0,
            promotionSubCode: item.promotionSubCode,
          };
          if(this.$route.query.record_type === RECORD_TYPE.UPSALE) {
            raw.giftIndexes = item.giftIndexes
          }
          return {
            // productCode: item.orderProductPromotions[0],
            promotionCode: item.promotionCode,
            giftSelected,
            giftIndexes: item.giftIndexes,
            type: promo.campaignType || 3,
            code: item.campaignCode,
            raw,
          };
        });
        const product = {
          id: item.id,
          isTransfered: item.isTransfered,
          comboId: item.comboId,
          activeType: item.activeType,
          type: item.productType.split('_')[1],
          curriculumId: productSKU?.curriculumId,
          teacherType: productSKU?.teacherTypeId,
          productId: item.productType.split('_')[1] == 'combo' ? item.comboId : item.productId,
          productName: productSKU?.name,
          count: item.quantity,
          price: item.price,
          discount: (item.quantity || 0) * (item.price || 0) - (item.intoMoney || 0),
          intoMoney: item.intoMoney,
          customerId: item.customerId,
          isNew: item.orderType === 1 ? true : false,
          isExtend: item.orderType === 2 ? true : false,
          packageOptions: [],
          products: skus,
          maxPrice: null,
          minPrice: null,
          package: `${productSKU?.classTypeId}-${productSKU?.numOfLesson}`,
          priceType: 'unchanged',
          campaigns: campaigns,
          trialExchangeStatus: this.detailOrder ? item.trialExchangeStatus : null,
          idBlock: uuidv1(),
        };
        await this.getClassType(product);
        return product;
      }));
      return results;
    },
    async fetchOrderHistory() {
      const params = {
        order_code: this.detailOrder.code,
      };
      const response = await OrderRepository.getHistory(params);
      if (response && response.status !== 200) {
        this.timelineEvents = response.data;
      }
    },

    showExtraPayment() {
      this.isShowDonePay = true;
    },
    reloadOrder(data) {
      this.extraData = data;
      this.isShowDonePay = false;
      this.isShowConfirmOrder = true;
      // this.fetchOrderHistory();
    },
    cancelPayOrder(string) {
      this.$swal({
          title: string,
          confirmButtonText: 'Xác nhận',
          showCancelButton: true,
          cancelButtonText: 'Huỷ'
      }).then((res) => {
          if (res.value) {
            this.cancelOrderPay(this.$route.query.order);
          }
      })
    },
    async cancelOrderPay(id) {
      const res = await OrderRepository.cancelOrderV2(id);
      if ( res && res.errors ) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: res.errors ? res.message : 'Có lỗi xảy ra'
        });
      } else {
        this.$swal({
          type: 'success',
          title: 'Thành công !',
          text: 'Hủy đơn hàng thành công'
        });
        await this.getOrderDetail(this.$route.query.order);
        this.products = await this.formatProducts(this.products);
      }
    },
    async cancelOneOrder(item) {
      const body = {
        status: "final_cancel"
      }
      const res = await OrderRepository.updateStatusHistoryOrderByID(item.id, body);
      if (res && res.errors) {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: res.errors ? res.errors.message : res.message || 'Có lỗi xảy ra'
        });
      } else {
        this.$swal({
          type: 'success',
          title: 'Thành công !',
          text: 'Huỷ phiếu thu thành công ! Vui lòng reload trang để tiếp tục.'
        });
       await this.getOrderReceipt()
        // this.fetchOrderHistory();
      }
    },
    viewDetailCombo(id) {
      this.comboIDSelect = id;
      this.isShowDetailCb = true;
    },
    closeDetailCb() {
      this.isShowDetailCb = false;
      this.comboIDSelect = null;
    },
    clickContact(contactId) {
      let routeData = this.$router.resolve({
        name: 'ContactDetail',
        params: {
          id: contactId || 0
        }
      });
      window.open(routeData.href, '_blank')
    },
    async getListProductTransference() {
      try {
        const response = await OrderRepository.getCheckOrderProductTransferenceApi(this.$route.query.order);
        if (response.success) {
          const orderProducts = response.data.orderProducts || [];
          const orderComboProducts = response.data.combos || [];

          const listProduct = orderProducts.filter(item => item.productTransference);
          const listComboProduct = orderComboProducts.filter(item => item.productTransference);

          const mergeOrderProducts = [...listProduct, ...listComboProduct];
          const mapListProduct = mergeOrderProducts.map(item => {
            return {
              ...item,
              labelProduct : item.productName + (item && item.remainNumberSession ? ` (Còn lại ${item.remainNumberSession} buổi)` : '')
            }
          })
          this.listProductTransference = _.cloneDeep(mapListProduct);
        }
      }catch (e) {
        console.log(e)
      }
    },


    async showPopupUpSale() {
      await Promise.all([
        this.getTutorSku(),
        this.getDuoSku(),
        this.getComboSku(),
      ])
      this.isShowPopupUpSale = true;
    },
    showChild(data) {
      const child = this.childs.find(
        (item) => item.customerId === data.customerId
      );
      if (child) {
        return child.fullName;
      }
      return "Chưa xác định";
    },
  },
};
</script>
<style lang="scss" scoped>
.group-into-money {
  height: 70vh;
}
.btn-order {
  width: 100%;
}
.chip-status {
  background: #FFE8E8;
  color: #20201F;
  border-radius: 20px;
  padding: 4px 8px;
}
.select-customer ::placeholder {
  color: rgb(172, 6, 6) !important;
  font-style: italic;
  font-size: 13px;
}
.custom-padding {
  .col-12,
  .col-1,
  .col-3,
  .col-4,
  .col-5,
  .col-6,
  .col-7,
  .col-8,
  .col-9,
  .col-11 {
    padding: 8px;
  }
}
.danger-text {
  color: #ff0000;
  border-radius: 20px;
  background-color: #ff550026;
  padding: 6px 8px;
  margin: 4px 0px;
}
</style>
